import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import routes from 'constants/routes';
import { RootState } from 'store';
import { isAdminOrSuperAdmin } from 'features/auth/helpers';
import { Layout } from 'features/common/components/Layout';
import { SellersTeamGoalList } from 'features/sellers/components/SellersTeamGoalList';

/**
 * "Vendedores: equipo y objetivo", en Administración. Como el menú, solo para administradores: el resto vuelve al
 * inicio (la API igual rechaza los cambios de otro rol).
 */
export const SellersTeamGoalPage = (): JSX.Element => {
	const user = useSelector((state: RootState) => state.auth.user);
	if (!isAdminOrSuperAdmin(user)) {
		return <Redirect to={routes.home} />;
	}
	return (
		<Layout>
			<Grid container paddingY={5} paddingX={3} spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h4" style={{ fontWeight: 500 }}>
						Vendedores: equipo y objetivo
					</Typography>
					<Typography variant="body2" color="text.secondary">
						El equipo y el objetivo mensual de margen bruto que usan el Home y los dashboards de ventas.
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<SellersTeamGoalList />
				</Grid>
			</Grid>
		</Layout>
	);
};
